export const en = {
  pageTitle: "Customers",
  pageSubtitle: "View Customers, Recent orders, and Follow-up activity.",
  errorNotFound: "Customer not found",
  openInShopify: "Open in Shopify →",
  activityOutcomePending: "Pending",
  filters: {
    all: "All",
    hasOpenActivity: "Has Open Activity",
    vipOnly: "VIP Only",
  },
  sort: {
    latestActivity: "Latest Activity",
    name: "Name",
    lastOrder: "Last Order",
    openActivities: "Open Activities",
  },
  columns: {
    customer: "Customer",
    phone: "Phone",
    lastOrder: "Last Order",
    openActivities: "Open Activities",
    latestActivityUpdate: "Latest Activity Update",
    latestUpdate: "Latest Update",
  },
  stats: {
    lifetimeSales: "Lifetime Sales",
    completedOrders: "Completed Orders",
    lastOrder: "Last Order",
    openActivities: "Open Activities",
    orders: "Orders",
  },
  tabs: {
    recentOrders: "Recent Orders",
    activities: "Activities",
  },
  empty: {
    notFound: "No customers found",
    orders: "No orders",
    activities: "No activities",
    title: "No customers found",
    description: "There are no customers to display.",
    filteredDescription: "No customers match your filters or search. Try adjusting them.",
  },
  error: {
    loadFailed: "Failed to load customers.",
    retry: "Retry",
  },
  order: {
    itemSingular: "item",
    itemPlural: "items",
    orderDate: "Order Date",
    paymentMethod: "Payment Method",
    source: "Source",
    tags: "Tags",
    lineItems: "Line Items ({{count}})",
    lastUpdated: "Last updated {{date}}",
    loadingDetails: "Loading order details...",
    errorTitle: "Error",
    errorLoadFailed: "Failed to load order details.",
    retry: "Retry",
    sources: {
      web: "Web",
      pos: "Point of Sale",
      shopify_draft_order: "Draft Order",
      subscription_contract: "Subscription",
      iphone: "iPhone",
      android: "Android",
      shopify_mobile: "Shopify Mobile",
      point_of_sale: "Point of Sale",
      shop: "Shop",
      api: "API",
      webhook: "Webhook",
    },
  },
  orderStatus: {
    FULFILLED: "Fulfilled",
    UNFULFILLED: "Unfulfilled",
    open: "Open",
    cancelled: "Cancelled",
    refunded: "Refunded",
    partial: "Partially Fulfilled",
    pending: "Pending",
    on_hold: "On Hold",
  },
} as const;
